import io from 'socket.io-client';
import { publicUrl } from './axios';
import { log } from './debug';

const socket = io(publicUrl, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 3000,
});

socket.on('connect', () => {
  log('Socket connected.', socket);
});

socket.on('disconnect', (reason) => {
  log('Socket disconnected.', socket);
  if (reason === 'io server disconnect') {
    // the disconnection was initiated by the server, you need to reconnect manually
    socket.connect();
  }
  // else the socket will automatically try to reconnect
});

socket.reconnect = (timeout = 1000) => {
  const t = socket.connected ? timeout : 0;
  if (socket.connected) {
    socket.disconnect();
  }
  setTimeout(() => socket.connect(), t);
};

export default socket;
